import { ngHttpLoaderConfigDefaults } from './ng-http-loader.config';
import { sessionConfigDefaults } from './session.config';

export const environment = {
  production: true,
  api: {
    initBase: 'https://api.mace.onpe.gob.pe',
    base: 'https://api.mace.onpe.gob.pe',
    protocol: 'http',
    version: 'v3'
  },
  googleMapsApiKey: 'AIzaSyAJIGdXf6fU0m9cYKjMgDwi4yL8OfRcaY8',
  recaptchaEnabled: true,
  authentication: {
    client_id: 'ushahidiui',
    client_secret: '35e7f0bca957836d05ca0492211b0ac707671261',
    token_header: 'authorization',
    token_ga_web: '6LcYjJotAAAAAMTQxECcGUanXt6OsWpWaKlyeJkO',
  },
  session: { ...sessionConfigDefaults },
  pieChart: {
    att_1: "mujeres-y-ninas",
    att_2: "pueblos-indigenas-y-afrodescendientes",
    att_3: "lgbtiq",
    tag: "f0c8b4a2-00f2-48d9-9817-32aee242f8e1"
  },
  ngHttpLoaderConfig: { ...ngHttpLoaderConfigDefaults },
  deploymentName: 'iReport Peru',
  footer: {
    visible: false,
    text: 'All rights reserved EC-UNDP Joint Task Force',
    links: [
      {
        text: 'Terms of use',
        link: ''
      },
      {
        text: 'Privacy Policy',
        link: ''
      }
    ]
  },
  format: {
    date: 'DD/MM/YYYY',
    time: 'hh:mm a',
    dateTime: 'DD/MM/YYYY hh:mm a',
    dateTimeWithoutSec: 'DD/MM/YYYY hh:mm a',
    mdY: 'MM/DD/YYYY'
  },
  form: {
    id: 1
  },
  geocoding: {
    provider: 'mapquest',
    mapquest: {
      url: 'https://nominatim.openstreetmap.org/search',
      key: ''
    }
  },
  defaults: {
    tagColor: '#4282c2',
    tagIncidentColor: '#3b746b',
    tagRiskColor: '#27b8ba',
    tagIcon: 'fa fa-map-marker',
    tagType: 'incident'
  },
  notifications: {
    enabled: true,
    timing: 900
  },
  countryCodes: [
    {
      countryCode: 'es',
      countryLanguage: 'Spanish'
    }
  ],
  availableLanguages:[
    "es"
  ],
  defaultLanguage: "es",
  defaultTimeZone: "Africa/Harare",
  defaultCountryCode: 'ZW',
  app_state_key: 'app_storage',
  xAxisLabel: 'Report dates',
  yAxisLabel: 'No of reports',
  flexmonster:{
    licenseKey : "Z7JN-XH2B4X-094T1X-0B1361-484G71-0F4T2A-4Q3M3O-311Q69-013I12-595P"
  },
  export: {
    timing: 5,
    expoerted_file_name: 'Reports.csv',
    expoerted_user_file_name: 'Users.csv'
  },
  riskMapOptions: [
    {
      name: 'FORECASTED_RISK',
      value: 0,
      isDefault: true
    },
    {
      name: 'EXTENDED_RISK',
      value: 1
    },
    {
      name: 'CURRENT_RISK',
      value: 2
    }
  ],
  mapRefreshInMinutes : 5
};
